import React, { memo } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Component
import DashboardLayout from '../../../layouts/DashboardLayout'
import { Container } from '../../../layouts/Container/Container'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import { inject, observer } from 'mobx-react'
import { Typography } from 'antd'
import InternalDocumentOutgoingDocCreateForm from './InternalDocumentOutgoingDocCreateForm'
import { useHistory } from 'react-router-dom'
import { systemName } from '../../../config'

const InternalDocumentOutgoingDocCreatePage = props => {
  const history = useHistory()

  return (
    <DashboardLayout>
      <Helmet>
        <title>Tạo văn bản đi | Quản lý VB {systemName}</title>
      </Helmet>
      <div style={{ padding: '24px 24px 0 24px', width: '100%', margin: '0 auto' }}>
        <Typography.Title level={3} style={{ margin: 0, fontWeight: 600 }}>Tạo văn bản đi</Typography.Title>
      </div>
      <div style={{ width: '100%', padding: '0 24px', paddingBottom: 40, margin: '0 auto' }}>
          <InternalDocumentOutgoingDocCreateForm
            handleCancel={() =>
              history.push('/internal-document/outgoing-document')
            }
          />
      </div>
    </DashboardLayout>
  )
}

InternalDocumentOutgoingDocCreatePage.propTypes = {}

export default memo(inject()(observer(InternalDocumentOutgoingDocCreatePage)))
